import {
  AnnounceRecording,
  CallRecording,
  CallRecordingSettingsOptions,
} from '@api/generated/graphql';
import { RecordingState, RecordingStatus } from '../types';

export const defaultRecordingState: RecordingState = {
  status: RecordingStatus.Unknown,
  disabled: true,
  announceRecording: AnnounceRecording.Unknown,
};

function getRecordingState(
  callRecording?: CallRecording | null,
): RecordingState {
  if (!callRecording) {
    return defaultRecordingState;
  }

  // user should not be able to change the recording state if the recording setting is set to NEVER or ALWAYS
  // UNSET means PCS should has not yet had a chance to process the recording setting.
  // It is my understanding that by the time we query for the conversation, the recording setting should already be set.
  const disabled =
    callRecording.settings === CallRecordingSettingsOptions.Never ||
    callRecording.settings === CallRecordingSettingsOptions.Always ||
    callRecording.settings === CallRecordingSettingsOptions.Unset;

  return {
    status: callRecording.status,
    disabled,
    announceRecording: callRecording.announceRecording,
  };
}

export default getRecordingState;
